import React from "react";
import styled from "styled-components";
import { TimePicker as AntTimePicker } from "antd";

const StyledTimePicker = styled(AntTimePicker)`
  &.ant-picker{width:100%}
  .ant-picker-input input {
    color: ${({ inputColor }) => inputColor || "inherit"};
  }
  &.ant-picker.ant-picker-disabled{
   .ant-picker-input input{color: var(--input-text-disabled) !important;}
  }
`;

const TimePicker = ({
  value,
  onChange,
  format = "HH:mm", 
  allowClear = true,
  use12Hours = false,
  size = "middle",
  placeholder = "Select a time",
  inputColor, 
  ...props
}) => {
  return (
    <StyledTimePicker
      value={value}
      onChange={onChange}
      format={format}
      allowClear={allowClear}
      use12Hours={use12Hours}
      size={size}
      placeholder={placeholder}
      inputColor={inputColor}
      {...props}
    />
  );
};

export default TimePicker;
